'use client';

import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { SectionHeader, styles } from '../../product-landing/ProductLanding';
import { blogArticles } from '../../../data/blogStore';
import { getArticleExcerpt, getLocalizedArticle } from '../../../data/blogUtils';
import benchmarkStyles from '../components/benchmark.module.scss';
import { useContentLanguage } from '../lib/pageLanguage';

const BENCHMARK_SLUG = 'czy-ai-zna-polskie-prawo-benchmark-mcp';

export default function BenchmarkSection() {
  const { t } = useTranslation('start');
  const article = blogArticles.find((item) => item.url === BENCHMARK_SLUG);
  // Polish on the server and in the first client render (hydration-safe).
  const language = useContentLanguage();
  const localized = article ? getLocalizedArticle(article, language) : null;
  return (
    <section className={`${styles.section} ${styles.band}`}>
      <div className={styles.split}>
        <div>
          <SectionHeader title={t('mcp.benchmark.title')} intro={t('mcp.benchmark.body')} left />
          <div className={benchmarkStyles.metric}>
            <strong>{t('mcp.benchmark.statHeadline')}</strong>
            <p>{t('mcp.benchmark.statCaption')}</p>
          </div>
        </div>
        {article && localized && (
          <Link href={`/blog/${article.url}`} className={benchmarkStyles.articleCard}>
            <img src={article.image} alt="" loading="lazy" />
            <div className={benchmarkStyles.articleBody}>
              <h3>{localized.title}</h3>
              <p>{getArticleExcerpt(article, language)}</p>
              <span>{t('mcp.benchmark.cta')}<ArrowForwardIcon fontSize="small" aria-hidden="true" /></span>
            </div>
          </Link>
        )}
      </div>
    </section>
  );
}
